import { IconProp, SizeProp } from "@fortawesome/fontawesome-svg-core"

export type CustomToolTipInfoProps = {
  label: string
  labelKey?: string
  icon: IconProp
  color?: "primary" | "secondary" | "error" | "info" | "success" | "warning"
}

export interface TooltipInfoIconProps {
  iconSize?: SizeProp
  type: TooltipInfoEnum
  custom?: CustomToolTipInfoProps
}

// export enum InfoStatusEnum {
//   Warning = "Warning",
//   Parked = "Parked",
//   ActiveUser = "ActiveUser",
//   InActiveUser = "InActiveUser",
//   Info = "Info"
// }

export enum TooltipInfoEnum {
  Passed = "Passed",
  Error = "Error",
  Warning = "Warning",
  Parked = "Parked",
  ActiveUser = "ActiveUser",
  InActiveUser = "InActiveUser",
  Info = "Info",
  Waiting = "Waiting",
  Failed = "Failed"
}
